import styled, { createGlobalStyle } from 'styled-components'

export const GlobalIconStyles = createGlobalStyle`
	.icon-grau1::before {
		color: ${ (props) => props.theme.colors['icon-grau1'] };
	}

  .icon-grey {
		color: ${ (props) => props.theme.colors['icon-grau1'] };
		fill: ${ (props) => props.theme.colors['icon-grau1'] };
  }

	.icon-size-16 {
		font-size: 16px;
	}
`

export const IconContainer = styled.span`
  &::before {
    animation: ${ (props) =>
      props.isSpinning ? 'icon-spin 1s infinite linear' : 'none' };
  }

  & > svg {
    fill: currentColor;
    width: ${ (props) => props.size }px;
    height: ${ (props) => props.size }px;
    animation: ${ (props) =>
      props.isSpinning ? 'icon-spin 1s infinite linear' : 'none' };
  }
`
